import { PropsWithChildren } from 'react';
import { Box, VStack } from '@primerai/thread';
import styled from 'styled-components';
import { PrimerLogo } from '~/components/branding/PrimerLogo';
import { BREAKPOINTS } from '~/components/theme/constants';

export const LoginContainer = styled.div<{ width?: string }>`
  width: ${({ width }) => width ?? '352px'};

  @media screen and (max-width: ${BREAKPOINTS.SM}) {
    width: 100%;
  }
`;

export const LoginWrapper = ({ children }: PropsWithChildren) => {
  return (
    <LoginContainer>
      <VStack gap="$6">
        <Box display="flex" justifyContent="center">
          <PrimerLogo height={28} />
        </Box>
        {children}
      </VStack>
    </LoginContainer>
  );
};
